import {
  Select,
  Popover,
  ListBox,
  ListBoxItem,
  Button,
} from "react-aria-components";
import CaretDownIcon from "@medoma/components/icons/CaretDownIcon";
import CheckFilledIcon from "@medoma/components/icons/CheckFilledIcon";
import styles from "./FilterPicker.module.scss";

type FilterPickerProps<T extends string | number> = {
  label: string;
  items: readonly { id: T; label: string }[];
  selected: ReadonlySet<T>;
  onSelectionChange: (next: Set<T>) => void;
};

export const FilterPicker = <T extends string | number>({
  label,
  items,
  selected,
  onSelectionChange,
}: FilterPickerProps<T>) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <Select
      aria-label={label}
      selectionMode="multiple"
      value={[...selected]}
      onChange={(keys) => onSelectionChange(new Set(keys as T[]))}
    >
      <Button className={styles.trigger}>
        <span>{label}</span>
        <span className={styles.triggerArrow} aria-hidden>
          <CaretDownIcon />
        </span>
      </Button>
      <Popover>
        <ListBox items={items} className={styles.content}>
          {(item) => (
            <ListBoxItem
              id={item.id}
              textValue={item.label}
              className={styles.item}
            >
              <span className={styles.itemCheck} aria-hidden>
                <CheckFilledIcon />
              </span>
              <span>{item.label}</span>
            </ListBoxItem>
          )}
        </ListBox>
      </Popover>
    </Select>
  );
};
